import moment from 'moment'

export const dateMixins = {
  methods: {
    /** Only Date Formate [ Created date and Updated Date ] */
    formatDate(date) {
      return moment(date).format('DD-MM-YYYY')
    },

    /** Date and Time [ Created and Updated Date] */
    formatDateTime(date) {
      return moment(date).format('DD-MM-YYYY hh:mm:ss A')
    },

    /** Created Date and Updated Date to TIME FORMAT */
    formatUTCTime(date) {
      return moment(date).format('HH:mm:ss')
    },

    /** Created Date and Updated Date to TIME FORMAT */
    formatLocalDateTime(date) {
      return moment(date).format('DD-MM-YYYY hh:mm:ss A')
    },

    /** Created Date and Updated Date to TIME FORMAT */
    formatLocal(date, format = 'DD-MM-YYYY hh:mm:ss A') {
      return moment(date).format(format)
    },

    /** 24Hrs to 12Hrs with AM PM */
    formatTime(time) {
      return moment(time, 'HH:mm:ss').format('hh:mm:ss A')
    },

    formatPlaneTime(time) {
      return moment(time, 'HH:mm:ss').format('hh:mm:ss')
    },

    formatText(text) {
      var i,
        text = text.split('_')
      for (i = 0; i < text.length; i++) {
        text[i] = text[i].charAt(0).toUpperCase() + text[i].slice(1)
      }
      return text.join(' ')
    }
  }
}
